var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.$vlastMode && _vm.$userIsClient
    ? _c(
        "a",
        {
          staticClass: "helpButton",
          attrs: { href: _vm.helpLink, target: "_blank" },
          on: { click: _vm.trackHelpClick },
        },
        [_c("i", { staticClass: "fa fa-life-buoy" }), _vm._v(" Help\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }